import { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import useAppState from '../../../../common/state/appState';
import { KmxContainer } from '../../../../components/KmxContainer';
import MobileRecentSearchesCarousel from './MobileRecentSearchesCarousel';
import HomePageExperience from '../../hero/store/HomePageExperience';

export const RecentSearchesContainer = () => {
    const experience = useAppState((state) => state.experience);
    const hasLoadedRecentSearches = useAppState((state) => state.hasLoadedRecentSearches);
    const recentSearches = useAppState((state) => state.recentSearches);
    const loadRecentSearches = useAppState((state) => state.loadRecentSearches);

    useEffect(() => {
        if (!hasLoadedRecentSearches) {
            loadRecentSearches();
        }
    }, [hasLoadedRecentSearches, loadRecentSearches]);

    if (experience === HomePageExperience.FirstTimeVisitor || !hasLoadedRecentSearches || recentSearches.length === 0) {
        return <></>;
    }

    return (
        <KmxContainer sx={{ pt: 8, display: { sm: 'none' } }}>
            <Stack direction="column" spacing={2}>
                <Typography component="h2" variant="h5">
                    You searched
                </Typography>
                <MobileRecentSearchesCarousel
                    ariaLabel="Recent vehicle searches"
                    carouselName="searched"
                    leftAligned={true}
                    recentSearchTileList={recentSearches}
                />
            </Stack>
        </KmxContainer>
    );
};
